import { urlEncode } from "./urlEncode";

export const urlEncodeParams = params =>
  Object.entries(params).reduce(
    (output, [key, value]) => ({
      ...output,
      [key]: urlEncode(value)
    }),
    {}
  );
